import React from 'react';
import { Fragment } from 'react';
import ToolBarMenu from './../../components/ToolBarMenu/index';
import Header from './../../components/Header/index';
import PageHeader from './../../components/PageHeader/index';
import Footer from './../../components/Footer/index';
import { useLicenses } from './../../queries/certificates';
import {getImagesWithAbsolutePath, myDomain} from '../../helpers/urlHelper';
import { useCertificatePageHeader } from './../../queries/certificatePageHeader';
import { Link } from 'react-router-dom';
import InfinitProgressBar from '../../components/InfiniteProgressBar';

const Certificates = () => {
    
    const {data, error, loading} = useLicenses()
    const certificatePage = useCertificatePageHeader();

    if (error) return <div>error!</div>
    if (loading) return <InfinitProgressBar />

    if (certificatePage.error) return <div>error!</div>
    if (certificatePage.loading) return <InfinitProgressBar />

  

    return (  data ?
        <Fragment>
            {/* <ToolBarMenu/> */}
            <Header/>
            <PageHeader
                // bgImg={require('../../assets/img/page-header.jpg')}
                // title='گواهینامه ها'
                // content=''
                bgImg={certificatePage.data.certificatePageHeader[0].certificatePageHeaderImage.urls[0]}
                title={certificatePage.data.certificatePageHeader[0].displayText}
                content={certificatePage.data.certificatePageHeader[0].certificatePageHeaderSubtitle.html}
            />

            <Fragment>
                <div className={`product-content-wrapper`}>
                    <div className="row">
                        {
                            data.licenses[0].licencesImageAndText.contentItems.map(i => 
                                // console.log(i)
                                <div className="card-container_ w-50">
                                    <div className="card u-clearfix_" style={{flexDirection:"row", height:"100%", minHeight: '400px', border:"none"}}>
                                        <div className="card-body_">
                                            <span className="card-author_ subtle_">{i.displayText}</span>
                                            <span className="card-description_ subtle_" dangerouslySetInnerHTML={{__html: i.htmlBody.html}}/>
                                          
                                        </div>
                                        <div className="card-media_">
                                            <Link to={`#`}>
                                                <img src={process.env.REACT_APP_BASE_URL + i.licenceImage.urls[0]} alt="" />
                                            </Link>
                                        </div>
        
                                    </div>
                                    <div className="card-shadow_"></div>
                                </div>
                                
                                )

                        }
                       
                    </div>
                </div>
            </Fragment>



            {/* <div style={{padding:"2% 10%", lineHeight:"40px"}} dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(data.licenses[0].htmlBody.html, myDomain)}} /> */}
            <br/>
            <br/>
            <br/>
            <Footer/>
        </Fragment>
   : null );
}
 
export default Certificates;